<app-card size="large" [fullHeight]="true" [background]="!isReadOnly()">
  <form [formGroup]="stepChallengeForm" data-test-id="step-challenges-form">
    <div class="top-actions">
      <app-title-section
        [title]="(initialValue() ? 'navigation.editChallenge' : 'navigation.createChallenge') | translate"
        [backButton]="true"
        [size]="3"
        [spacingBottom]="0"
        (handlePressBack)="onBack()"
      ></app-title-section>
      @if (isSaving()) {
      <app-spinner
        size="20px"
        thickness="1px"
        data-test-id="step-challenges-saving-spinner"
      ></app-spinner>
      } @else {
      <app-form-action-button
        [type]="!isReadOnly() ? 'save' : 'edit'"
        (handleClick)="!isReadOnly() ? onSave() : onEditRequested()"
        data-test-id="step-challenges-save-edit-button"
      ></app-form-action-button>
      }
    </div>
    <div>
      <app-title-section
        title="{{ 'challenges.stepChallengeTitle' | translate }}"
        [size]="2"
        [spacingBottom]="40"
        data-test-id="step-challenges-title-section-challenge"
      ></app-title-section>
      <app-input
        labelData="{{ 'challenges.labelTitle' | translate }}"
        variant="outline"
        width="full"
        spacingBottom="16"
        [error]="!!errors().title"
        [errorMessage]="errors().title"
        [maxLength]="255"
        [disabled]="isReadOnly()"
        data-test-id="step-challenges-input-title"
        formControlName="title"
      ></app-input>
      <app-input
        labelData="{{ 'challenges.labelDescription' | translate }}"
        variant="outline"
        width="full"
        [multiLine]="true"
        spacingBottom="16"
        formControlName="description"
        [error]="!!errors().description"
        [errorMessage]="errors().description"
        [disabled]="isReadOnly()"
        data-test-id="step-challenges-input-description"
      ></app-input>
      <div class="duration-row">
        <div class="field-wrapper">
          <app-input
            labelData="{{ 'challenges.labelDuration' | translate }}"
            variant="outline"
            spacingBottom="16"
            type="number"
            width="fixed-number"
            formControlName="duration"
            [error]="!!errors().duration"
            [errorMessage]="errors().duration"
            [disabled]="isReadOnly() || isStartDateLocked()"
            data-test-id="step-challenges-input-duration"
          ></app-input>
          <app-select-dropdown
            [optionsObj]="durationUnits"
            [showPlaceholder]="false"
            formControlName="durationUnit"
            height="small"
            [disabled]="isReadOnly() || isStartDateLocked()"
          ></app-select-dropdown>
        </div>
        <div class="goal-group" data-test-id="step-challenges-daily-step-limit">
          <label class="label"
            >{{ 'challenges.labelDailyStepLimit' | translate }}
            <span class="secondary-label">{{
              'challenges.labelDailyStepLimitSecondary' | translate
            }}</span></label
          >
          <app-select-dropdown
            [optionsObj]="dailyStepLimitOptions"
            [showPlaceholder]="false"
            formControlName="dailyStepLimit"
            height="small"
            [disabled]="isReadOnly()"
          ></app-select-dropdown>
        </div>
      </div>

      <app-title-section
        title="Team Assignment"
        [size]="2"
        [spacingBottom]="16"
      ></app-title-section>
      <div
        class="team-assigment-options"
        data-test-id="step-challenges-team-assignment-options"
      >
        @for (option of teamAssignmentOptions; track option.type) {
        <div class="team-assigment-option">
          <app-toggle
            (handleChecked)="onSelectTeamAssignment(option.type)"
            [checked]="teamAssignmentType() === option.type"
            [disabled]="isReadOnly()"
            color="#14E25A"
            size="small"
            [attr.data-test-id]="getAssignmentDataTestId(option.type)"
          ></app-toggle>
          <app-text color="neutral-7" [size]="16" [spacingBottom]="24">{{
            option.label | translate
          }}</app-text>
        </div>
        }
      </div>
      <div>
        @if (teamAssignmentType() === stepChallengeTeamAssignmentType.DEFAULT) {
        <app-text
          color="neutral-7"
          [size]="16"
          [spacingBottom]="8"
          class="team-assigment-title"
          data-test-id="step-challenges-default-assignment-title"
          >{{
            'groupChallenges.defaultTeamAssignmentStrategyTitle' | translate
          }}</app-text
        >
        <app-text
          color="neutral-6"
          [size]="14"
          [weight]="400"
          [height]="22"
          [spacingBottom]="40"
          data-test-id="step-challenges-default-assignment-requirement"
          >{{
            'groupChallenges.defaultTeamAssignmentRequirement' | translate
          }}</app-text
        >
        } @else if (teamAssignmentType() ===
        stepChallengeTeamAssignmentType.FIXED_TEAM_COUNT) {
        <app-text
          color="neutral-7"
          [size]="16"
          [spacingBottom]="8"
          class="team-assigment-title"
          data-test-id="step-challenges-fixed-team-count-assignment-title"
          >{{
            'groupChallenges.fixCountTeamAssignmentStrategyTitle' | translate
          }}</app-text
        >
        <app-text
          color="neutral-6"
          [size]="14"
          [weight]="400"
          [height]="22"
          [spacingBottom]="24"
          data-test-id="step-challenges-fixed-team-count-assignment-requirement"
          >{{
            'groupChallenges.fixCountTeamAssignmentRequirement' | translate
          }}</app-text
        >
        <app-input
          labelData="{{
            'groupChallenges.fixCountTeamAssignmentNote' | translate
          }}"
          variant="outline"
          width="fixed-number"
          type="number"
          formControlName="numberOfTeams"
          spacingBottom="40"
          [error]="!!errors().numberOfTeams"
          [errorMessage]="errors().numberOfTeams"
          [disabled]="isReadOnly()"
          data-test-id="step-challenges-input-number-of-teams"
          [maxLength]="3"
        ></app-input>
        } @else if (teamAssignmentType() ===
        stepChallengeTeamAssignmentType.MAX_TEAM_SIZE) {
        <app-text
          color="neutral-7"
          [size]="16"
          [spacingBottom]="8"
          class="team-assigment-title"
          data-test-id="step-challenges-fixed-team-size-assignment-title"
          >{{
            'groupChallenges.maxTeamAssignmentStrategyTitle' | translate
          }}</app-text
        >
        <app-text
          color="neutral-6"
          [size]="14"
          [weight]="400"
          [height]="22"
          [spacingBottom]="24"
          data-test-id="step-challenges-fixed-team-size-assignment-requirement"
          >{{
            'groupChallenges.maxTeamAssignmentRequirement' | translate
          }}</app-text
        >
        <app-input
          labelData="{{ 'groupChallenges.maxTeamAssignmentNote' | translate }}"
          variant="outline"
          type="number"
          width="fixed-number"
          formControlName="maxTeamNumber"
          spacingBottom="40"
          [error]="!!errors().maxTeamNumber"
          [errorMessage]="errors().maxTeamNumber"
          [disabled]="isReadOnly()"
          data-test-id="step-challenges-input-max-team-number"
          [maxLength]="3"
        ></app-input>
        }
      </div>

      <app-title-section
        title="Dates"
        [size]="2"
        [spacingBottom]="24"
      ></app-title-section>
      <app-input
        labelData="{{ 'challenges.signupDate' | translate }}"
        info="{{ 'challenges.signupDateInfo' | translate }}"
        variant="outline"
        type="date"
        width="fixed-date"
        spacingBottom="16"
        formControlName="signupDate"
        [error]="!!errors().signupDate"
        [errorMessage]="errors().signupDate"
        [disabled]="isReadOnly() || isSignupDateLocked()"
        data-test-id="step-challenges-input-signup-date"
      ></app-input>
      <div class="date-row">
        <app-input
          labelData="{{ 'challenges.startDate' | translate }}"
          info="{{ 'challenges.startDateInfo' | translate }}"
          variant="outline"
          type="date"
          width="fixed-date"
          formControlName="startDate"
          [error]="!!errors().startDate"
          [errorMessage]="errors().startDate"
          [disabled]="isReadOnly() || isStartDateLocked()"
          dateRestriction="futureOnly"
          data-test-id="step-challenges-input-start-date"
        ></app-input>
        <app-input
          labelData="{{ 'challenges.endDate' | translate }}"
          type="date"
          info="{{ 'challenges.endDateInfo' | translate }}"
          width="fixed-date"
          formControlName="endDate"
          [disabled]="true"
          data-test-id="step-challenges-input-end-date"
        ></app-input>
      </div>
      <div class="challenge-options" data-test-id="step-challenges-options">
        <app-toggle
          (handleChecked)="handleCheck()"
          [checked]="isCanJoinAfterStart()"
          [disabled]="isReadOnly()"
          color="#14E25A"
          size="small"
          data-test-id="step-challenges-toggle-allow-joining"
        ></app-toggle>
        <app-text color="neutral-7" [size]="16">{{
          'challenges.allowJoiningAfterStartHeader' | translate
        }}</app-text>
        <app-text
          class="challenge-options-body"
          color="neutral-6"
          [size]="14"
          [weight]="400"
          [height]="22"
          >{{ 'challenges.allowJoiningAfterStartBody' | translate }}</app-text
        >
      </div>
    </div>
  </form>
</app-card>
